import React from 'react';
import sgaLogo from '../../images/SGANewLogoConverted.png';
import './SpinnerSga.scss';

const SpinnerSga = ({ className = '', ...props }) => {
    return (
        <div {...props} className={`sga-logo ${className}`}>
            <img className="sga-svg" src={sgaLogo} alt="SGA Logo" />
            <div className="sga-square"></div>
        </div>
    );
}

export default SpinnerSga;